import React from "react";
export const GenericSearchIcon = props => {
    const { className, fillColor } = props;
    const fill = fillColor || "#0C172F";
    return (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path fillRule="evenodd" clipRule="evenodd" d="M12.438 13.1451C11.1188 14.3001 9.39113 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 9.39113 14.3001 11.1188 13.1451 12.438L17.8536 17.1464C18.0488 17.3417 18.0488 17.6583 17.8536 17.8536C17.6583 18.0488 17.3417 18.0488 17.1464 17.8536L12.438 13.1451ZM14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5Z" fill={fill}/>
		</svg>);
};
